import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {APIService} from "./api.service";
import {ICausableBalance} from "../interfaces/causable/ICausableBalance";
import {ICausablePayment} from "../interfaces/causable/ICausablePayment";
import {IRecordCausablePaymentCommand} from "../interfaces/commands/IRecordCausablePaymentCommand";

/**
 * Causable's receivable ledger — what each organization owes Causable in fees, and the remittances
 * it has paid. Causable-internal: every endpoint behind it is CausableAdminOnly.
 */
@Injectable({
  providedIn: 'root'
})
export class CausablePaymentService {

  private apiService: APIService = inject(APIService);

  public fetchBalanceByGameId(gameIdP: string): Observable<ICausableBalance> {
    return this.apiService.MakeGetRequest<ICausableBalance>(`causable-payment/balance/${gameIdP}`);
  }

  public fetchPaymentsByGameId(gameIdP: string): Observable<ICausablePayment[]> {
    return this.apiService.MakeGetRequest<ICausablePayment[]>(`causable-payment/by-game/${gameIdP}`);
  }

  public recordCausablePayment(commandP: IRecordCausablePaymentCommand): Observable<{ CausablePaymentId: string }> {
    return this.apiService.MakePostRequest<{ CausablePaymentId: string }>('causable-payment', commandP);
  }

  /** Voids a remittance so it stops counting toward paid. The row is kept for audit, not deleted. */
  public voidCausablePayment(gameIdP: string, causablePaymentIdP: string): Observable<void> {
    return this.apiService.MakePutRequest<void>('causable-payment/void', {
      GameId: gameIdP,
      CausablePaymentId: causablePaymentIdP
    });
  }
}
